"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slider as ChakraSlider, SliderTrack, SliderFilledTrack, SliderThumb, SliderMark, Text, forwardRef, } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../../atoms";
import { Icons } from "../../../assets";
var SliderVariant;
(function (SliderVariant) {
    SliderVariant["DEFAULT"] = "default";
    SliderVariant["WITH_ICON"] = "withIcon";
})(SliderVariant || (SliderVariant = {}));
const Slider = forwardRef((_a, ref) => {
    var { withThumbIcon = false, value = 0, markLabel, isDisabled, focusThumbOnChange = false } = _a, rest = __rest(_a, ["withThumbIcon", "value", "markLabel", "isDisabled", "focusThumbOnChange"]);
    return (_jsxs(ChakraSlider, Object.assign({ ref: ref, isDisabled: isDisabled, value: value, variant: withThumbIcon ? SliderVariant.WITH_ICON : SliderVariant.DEFAULT, focusThumbOnChange: focusThumbOnChange }, rest, { children: [_jsx(SliderTrack, { children: _jsx(SliderFilledTrack, { backgroundColor: isDisabled
                        ? "semantic.background.disabled"
                        : "semantic.foreground.primary" }) }), markLabel ? (_jsx(SliderMark, Object.assign({ value: value }, { children: _jsx(Text, Object.assign({ variant: "body.largeDemibold" }, { children: markLabel })) }))) : null, _jsx(SliderThumb, { children: withThumbIcon ? (_jsx(SvgSpriteConsumer, { svgId: Icons.PLUS_CIRCLE_FILLED24, size: 24 })) : null })] })));
});
Slider.displayName = "Slider";
export default Slider;
//# sourceMappingURL=Slider.js.map